module.exports = __webpack_public_path__ + "static/media/GY.c27bcfb2.png";